import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "use-intl";
import { FeesContentLayout } from "./FeesContentLayout";
export function FeesContentLayoutError(t0) {
  const $ = _c(7);
  const {
    icon,
    title,
    footer
  } = t0;
  const t = useTranslations("wallet.FeesContentLayoutError");
  let t1;
  if ($[0] !== t) {
    t1 = t("body");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== footer || $[3] !== icon || $[4] !== t1 || $[5] !== title) {
    t2 = <FeesContentLayout body={t1} footer={footer} icon={icon} title={title} />;
    $[2] = footer;
    $[3] = icon;
    $[4] = t1;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}